import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { CardElement, injectStripe } from 'react-stripe-elements';
import * as actions from 'redux/actions/index';


import { routes } from 'Utility/constants';
import Loader from 'react-loader-spinner';
import { toastMsg } from 'Utility/utility';
import {stripe_plan_id} from "config"


const Payment = (props) => {
   const name = props.user.first_name.concat(' ', props.user.last_name);
   let dispatch = useDispatch();
   let isLoading = useSelector((state) => state.authReducer.isLoading);

   let [couponCode, setCouponCode] = useState();
   const handleChange = (e) => {
      e.preventDefault();
      setCouponCode(e.target.value);
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      let token = await props.stripe.createToken({ name: name });
      let card_token;
      if (!token.error) {
         card_token = token.token.id;
      }
      let data = {};
      if (card_token) {
         data = {
            platform: 'stripe',
            product_id: props.planid,
            coupon: couponCode,
         };
         dispatch(actions.addCard({ card_token }, data));
      } else {
         toastMsg('Please add valid card details to proceed!', true);
      }
   };

   const checkCoupon = (coupon_code) => {
      coupon_code.preventDefault();
      coupon_code = document.getElementById('coupon_code').value;
      let PLAN_ID = stripe_plan_id(props?.planid);
      dispatch(actions.couponCheck(coupon_code, PLAN_ID));
   };

   useEffect(() => {
      if (!props.planid) {
         props.history.push(routes.PLANS);
      }
   }, []);

   let [discount, setDiscount] = useState('None');
   let [isDiscount, setIsDiscount] = useState(false);

   useEffect(() => {
      if (props.discountPrice && props.discountPrice.length > 0) {
         props.discountPrice.map((price) => {
            if (price.id === props.planid) {

               if (
                  price.discounted_price !== null &&
                  price.discounted_price !== 0
               ) {
                  setDiscount(`$${(price.discounted_price / 100).toFixed(2)}
                     for the first year`);
                  setIsDiscount(true);
                  toastMsg('Coupon Code Applied');
               } else if (price.discounted_price === 0) {
                  if (price.interval === "month") {
                     setDiscount(
                        `3 Month free trial, ${props.planPrice} after the trial ends`
                     );
                  } else {
                     setDiscount(
                        `1 Year free trial, ${props.planPrice} after the trial ends`
                     );
                  }
                  setIsDiscount(true);
                  toastMsg('Coupon Code Applied');
               }
               else {
                  toastMsg('Coupon Code is invalid for this Plan', true);
               }

            }
         });
      }

      return dispatch(actions.clearCoupon());
   }, [props.discountPrice]);

   let [isMonthly, setisMonthly] = useState(false);

   useEffect(() => {
      if (props.planName === 'Monthly') {
         setisMonthly(true);
      }
   }, [isMonthly]);

   return (
      <div id="wrap">
         <section className="ihWeb_sec theme_nav_mt">
            <div className="container">
               <div className="row">
                  <div className="col-md-12 col-lg-10 mx-auto">
                     <div className="card ihWeb_card">
                        <div className="card-body">
                           <article className="ihWeb_art">
                              <h3 className="border-bottom mb-0 pb-2">
                                 Order Summary
                              </h3>
                           </article>
                           <form className="ihWeb_form" id="profile_form">
                              <fieldset className="mt-3">
                                 <div className="row align-items-center">
                                    <div className="col-6 col-lg-4">
                                       <h4 className="mb-0">Product</h4>
                                    </div>
                                    <div className="col-6 col-lg-8">
                                       <div className="row">
                                          <div className="col-sm-4">
                                             <div className="form-group">
                                                <h4
                                                   style={{ marginTop: '11px' }}
                                                >
                                                   {' '}
                                                   {props.planName}
                                                </h4>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <br />
                                 <div className="row align-items-center">
                                    <div className="col-6 col-lg-4">
                                       <h4 className="mb-0">Price</h4>
                                    </div>
                                    <div className="col-6 col-lg-8">
                                       <div className="row">
                                          <div className="col-sm-4">
                                             <div className="form-group">
                                                {isDiscount ? (
                                                   <h4>
                                                      <strike>
                                                         {props.planPrice}
                                                      </strike>
                                                   </h4>
                                                ) : (
                                                   <h4>{props.planPrice}</h4>
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 {isDiscount ? (
                                    <div className="row align-items-center">
                                       <div className="col-6 col-lg-4">
                                          <h4 className="mb-0">
                                             Discounted Price
                                          </h4>
                                       </div>
                                       <div className="col-6 col-lg-8">
                                          <div className="row">
                                             <div className="col-sm-7">
                                                <div className="form-group">
                                                   <label className="label_modify" />

                                                   <h4
                                                      style={{
                                                         marginTop: '-2px',
                                                      }}
                                                   >
                                                      {discount}
                                                   </h4>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 ) : null}
                              </fieldset>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <br />
            <div className="container">
               <div className="row">
                  <div className="col-md-12 col-lg-10 mx-auto">
                     <div className="card ihWeb_card">
                        <div className="card-body">
                           <article className="ihWeb_art">
                              <h3 className="border-bottom mb-0 pb-2">
                                 Payment Information
                              </h3>
                           </article>
                           <form className="ihWeb_form" id="profile_form">
                              <fieldset className="mt-3">
                                 <div className="row align-items-center">
                                    <div className="col-lg-4">
                                       <h4 className="mb-0">
                                          Billling information
                                       </h4>
                                    </div>
                                    <div className="col-lg-8">
                                       <div className="row">
                                          <div className="col-sm-4">
                                             <div className="form-group">
                                                <label className="label_modify">
                                                   First Name
                                                </label>
                                                <input
                                                   type="text"
                                                   className="input_modify"
                                                   value={props.user.first_name}
                                                   readOnly
                                                />
                                             </div>
                                          </div>
                                          <div className="col-sm-4">
                                             <div className="form-group">
                                                <label className="label_modify">
                                                   Last Name
                                                </label>
                                                <input
                                                   type="text"
                                                   className="input_modify"
                                                   value={props.user.last_name}
                                                   readOnly
                                                />
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                                 <div className="row align-items-center">
                                    <div className="col-lg-4">
                                       <h4 className="mb-0">Card Details</h4>
                                    </div>
                                    <div className="col-lg-8">
                                       <div className="form-group">
                                          <label className="label_modify"></label>
                                          <div
                                             className="input_modify"
                                             style={{ paddingTop: '14px' }}
                                          >
                                             <CardElement
                                                style={{
                                                   base: {
                                                      fontSize: '18px',
                                                   },
                                                   invalid: {
                                                      iconColor: '#FFC7EE',
                                                      color: 'red',
                                                   },
                                                }}
                                             />
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                                 <div className="row align-items-center">
                                    <div className="col-lg-4">
                                       <h4 className="mb-0">Coupon Code</h4>
                                    </div>
                                    <div className="col-lg-8">
                                       <div className="row">
                                          <div
                                             className="col-sm-4"
                                             style={{
                                                paddingLeft: '15px',
                                             }}
                                          >
                                             <div className="form-group">
                                                <label className="label_modify"></label>
                                                <input
                                                   type="text"
                                                   id="coupon_code"
                                                   className="input_modify"
                                                   onChange={handleChange}
                                                />
                                             </div>
                                          </div>
                                          <div
                                             className="col-sm-4"
                                             style={{
                                                padding: '0px 0px',
                                             }}
                                          >
                                             <div className="form-group">
                                                <label className="label_modify"></label>
                                                <div
                                                   className="input_modify"
                                                   style={{
                                                      border: 'none',
                                                      padding: '0px 15px',
                                                   }}
                                                >
                                                   <button
                                                      className="theme_btn theme_primary"
                                                      onClick={checkCoupon}
                                                      disabled={!couponCode}
                                                   >
                                                      Apply
                                                   </button>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>


                                 <div className="row">
                                    <div className="col-sm-12">
                                       <div class="subscribe_btn_wrp text-center">
                                          <button
                                             disabled={isLoading ? true : false}
                                             type="submit"
                                             className="theme_btn theme_primary"
                                             onClick={handleSubmit}
                                          >
                                             {isLoading ? (
                                                <Loader
                                                   type="Circles"
                                                   color="#FFF"
                                                   height={25}
                                                   width={130}
                                                />
                                             ) : (
                                                'Subscribe Now'
                                             )}
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                              </fieldset>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
      planid: state.authReducer.planid,
      planName: state.authReducer.planName,
      planPrice: state.authReducer.planPrice,
      discountPrice: state.authReducer.discountPrice,
   };
};

export default injectStripe(connect(mapStateToProps)(Payment));
